export default __webpack_public_path__ + "static/media/Solarlarten.4c5ed56e.png";